import { createContext, useContext } from 'react';
import { defaultDefinitions, featureName } from '../utils/featureCatalog';

// Presentation can also run outside a company session (for example plan cards).
export const FeatureCatalogContext = createContext({definitions:defaultDefinitions,featureName:key => featureName(key)});
export const useFeatureCatalog = () => useContext(FeatureCatalogContext);
